
export interface GenericGameProps {
    baseApiUrl: string | null;
    gameid: string | number;
    players?: number;
    token?: string | number | null;
    hash?: string | null;
    data?: object;
    action?: 'create' | 'join' | 'leave' | 'disband';
}

const useUpdateGameData = () => {
    const getGameLobbyStatus = async ({ baseApiUrl, gameid, token = '' } : { baseApiUrl: string | null, gameid: string | number, token: string | number }) => {
        const url = `${baseApiUrl}games/${gameid}/lobby`;
        const abortController = new AbortController();

        try {
            const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type' : 'application/json',
                        mode: 'cors',
                        Cookie: `token=${token}`
                    },
                    signal: abortController.signal
                }
            );

            if (response.status === 200) {
                const data = await response.json();
                return data;
            } else {
                return null;
            }
        } catch(error) {
            console.log(`Error: ${error}`);
            return null;
        }
    }

    const gameLobbyAction = async ({ baseApiUrl, gameid, players, token = '', data = {}, action = 'join' } : GenericGameProps) => {
        const url = `${baseApiUrl}games/${gameid}/lobby`;
        const abortController = new AbortController();

        try {
            const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type' : 'application/json',
                        mode: 'cors'
                    },
                    body: JSON.stringify({
                        token,
                        players,
                        action,
                        ...data
                    }),
                    signal: abortController.signal
                }
            );

            if (response.status === 200) {
                const data = await response.json();
                return data;
            } else {
                return null;
            }
        } catch(error) {
            console.log(`Error: ${error}`);
            return null;
        }
    };

    const updateGameData = async ({ baseApiUrl, gameid, token = '', hash = null, data = {} } : GenericGameProps) => {
        const url = `${baseApiUrl}games/${hash ? `${hash}/share` : `${gameid}/win`}`;
        const abortController = new AbortController();

        try {
            const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type' : 'application/json',
                        mode: 'cors'
                    },
                    body: JSON.stringify({
                        token,
                        ...data
                    }),
                    signal: abortController.signal
                }
            );

            if (response.status === 200) {
                const data = await response.json();
                return data;
            } else {
                return null;
            }
        } catch(error) {
            console.log(`Error: ${error}`);
            return null;
        }
    };

    const getGameData = async ({ baseApiUrl, gameid, hash = '', token = null } : GenericGameProps) => {
        const url = `${baseApiUrl}games/${gameid}/share/${hash}`;
        const abortController = new AbortController();

        try {
            const response = await fetch(url, {
                    method: token ? 'POST' : 'GET',
                    headers: {
                        'Content-Type' : 'application/json',
                        mode: 'cors'
                    },
                    body: token ? JSON.stringify({ token }) : null,
                    signal: abortController.signal
                }
            );

            if (response.status === 200) {
                const data = await response.json();
                return data;
            } else {
                return null;
            }
        } catch(error) {
            console.log(`Error: ${error}`);
            return null;
        }
    };

    return {
        getGameLobbyStatus,
        gameLobbyAction,
        getGameData,
        updateGameData,
    };
};

export default useUpdateGameData;